import { render, staticRenderFns } from "./Integridade.vue?vue&type=template&id=34d052d8&scoped=true&"
import script from "./Integridade.vue?vue&type=script&lang=js&"
export * from "./Integridade.vue?vue&type=script&lang=js&"
import style0 from "./Integridade.vue?vue&type=style&index=0&id=34d052d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d052d8",
  null
  
)

export default component.exports